import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment userSavings on UserSaving {
    userSavings {
      header
      type
      value
    }
  }
`

export default fragment
